import { Navigate, useParams } from 'react-router';

import { AuthProvider } from '../../components/AuthProvider';

export const AuthPage = () => {
  const { type } = useParams<{ type: 'figma' | 'google' }>();

  if (!type) return <Navigate to="/" />;
  
  return <AuthProvider type={type} />;
};
